import Vue from "vue";
import Vuex from "vuex";
import * as d3 from 'd3';


Vue.use(Vuex);

function accessYearDatas(data) {

   var catArray = []
    for (var key in data) {
      var oneCategory = new Object();
      var x = 1;
      var y = 1;
      var color = '#DBDEEF';
      switch (key){

        case "Autres":
            x = 2
            y = 12
            color ='#39437b'
            break;
        case "Biens divers":
          x = 11
          y = 8
           color='#445094'
          break;
        case "Forex":
          x = 5
          y = 7
          color='#505ead'
          break;
        case "Champagne":
          x=14
          y=6
          color='#6874ba'
          break;
        case "Cheptel":
          x=12
          y=4
          color='#818cc5'
          break;
        case "Crowdfunding":
          x=16
          y=9
          color='#002253'
          break;
        case "Crypto-actifs":
          x = 11
          y = 14
          color='#cdd1e8'
          break;
        case "Diamants":
          x = 2
          y = 3
          color='#9aa3d1'
          break;
        case "Options binaires":
          x= 10
          y= 9
          color='#133463'
          break;
        case "Or":
          x = 8
          y = 15
          color='#00ABD8'
          break;
        case "Terres rares":
          x = 7
          y = 13
          color='#0c0e1a'
          break;
        case"Usurpation":
          x = 17
          y = 13
          color='#0288D1'
          break;
        case "Usurpation AMF":
          x = 14
          y = 16
          color='#ACF0F2'
          break;
        case"Vins":
          x = 16
          y = 3
          color='#15192e'
          break;
        case "Whisky":
          x = 18
          y = 6
          color='#b4badc'
          break;

      }

      //y = Math.random() * 20
      oneCategory["x"] = x;
      oneCategory["y"] = y;
      oneCategory["color"] = color;
      if (Number(data[key]) > 0) {
        oneCategory["z"] = Number(data[key]);
        oneCategory["name"] = key
        catArray.push(oneCategory)
      }
    }
    catArray.shift()
    return catArray

  }

export default new Vuex.Store({
  state: {
    cat_graph:[],
    year_graph:[],
    name:[],
    intro: true,
    ampleur: false,
    mecanique: false,
    victimes: false,
    date:'',
      },

  /*########################### MUTATIONS  ###################################*/




  mutations: {
    SET_CAT_GRAPH(state, datas) {
      state.cat_graph = datas
    },
    SET_YEAR_GRAPH(state, datas) {
      state.year_graph = datas
    },
    SET_READING_INTRO(state) {
      state.intro = true
    },
    SET_READING_AMPLEUR(state) {
      state.ampleur = true
    },
    SET_READING_MECANIQUE(state) {
      state.mecanique = true
    },
    SET_READING_VICTIMES(state) {
      state.victimes = true
    },
    SET_REINITIALIZATION(state) {
      state.intro = false,
        state.ampleur = false,
        state.mecanique = false,
        state.victimes = false
    },
   /* SET_SAFARI(state){
      state.isSafari = true
    },*/
    SET_DATE(state, maDate){
      state.date = maDate
    },
    SET_NAME(state, payload){
      state.name = payload
    },

  },

  /*########################### ACTIONS ###################################*/



  actions: {
    fetchReading({ commit }, status) {
      commit('SET_REINITIALIZATION')
      if (status == "intro") {
        commit('SET_READING_INTRO')
      }
      else if (status == "ampleur") {
        commit('SET_READING_AMPLEUR')
      }
      else if (status == "mecanique") {
        commit('SET_READING_MECANIQUE')
      }
      else if (status == "victimes") {
        commit('SET_READING_VICTIMES')
      }
      else {
        console.log("error in fetchReading");
      }
    },
    loadCategories({ commit }){
      d3.csv('/data/database-graph-cat.csv').then(function(data, error){
        console.log("ceci est l'erreur LOAD CAT" + error)
        commit('SET_CAT_GRAPH', data)
      }); 
    },
    loadYears({ commit }){
      d3.csv('/data/database-graph-year.csv').then(function(data, error){
      console.log("ceci est l'erreur" + error)
      var finaltempArray = []

      for (var i = 0; i < data.length; i++) {
          var temporary_array = []
        temporary_array.push(Number(data[i].Année))
        temporary_array.push(Number(data[i].Nombre))
        finaltempArray.push(temporary_array)
    }
      commit('SET_YEAR_GRAPH',finaltempArray)
      }); 
    },
    loadName({commit}) {
      d3.csv('/data/database-10-adress.csv').then(function (data, error) {
        console.log("ceci est l'erreur" + error)

        // nettoyage des noms
        var tmpData = []
        for (var i = 0; i < (data.length); i++) {
          var myData = data[i].Nombre

          if (myData.startsWith("www.")) {
            let myDatasplited = myData.split(".")
            tmpData.push([myDatasplited[1], 1])
          }
          else if (myData.startsWith("http") || myData.startsWith("https")) {
            let myDatasplited = myData.split("//")
            if (myData.endsWith(".com") || myData.endsWith(".fr")) {
              let myFinalData = myDatasplited[1].split(".")
              console.log(myFinalData[myFinalData.length - 2])
              tmpData.push([myFinalData[myFinalData.length - 2], 1])
            } else {
              tmpData.push([myDatasplited[1], 1])
            }

          }
          else {
            let myDatasplited = myData.split(".")
            tmpData.push([myDatasplited[0], 1])
          }

        }

        commit('SET_NAME', tmpData)
      });
    },
   /* detectSafari({commit}){
      var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
          navigator.userAgent &&
          navigator.userAgent.indexOf('CriOS') == -1 &&
          navigator.userAgent.indexOf('FxiOS') == -1;
      console.log(isSafari)
      commit('SET_SAFARI', isSafari)
    },
    updateSafari({commit}){
      commit('SET_SAFARI')
    },*/
    loadDate({commit}){
      d3.csv("/data/mydate.csv").then(function (data){

        commit('SET_DATE',data[0].date)
      })
    },
     },
/*########################### GETTERS ###################################*/
  getters: {
    cat_graph(state) {
      return state.cat_graph
       },
    year_graph(state) {
      return state.year_graph
    },
    year_graph_length(state){
      return state.year_graph.length
    },
    reading_intro(state) {
      return state.intro
    },
    reading_ampleur(state) {
      return state.ampleur
    },
    reading_mecanique(state) {
      return state.mecanique
    },
    reading_victimes(state) {
      return state.victimes
    },
    total_site(state){
      var sum = 0
      for (var i = 0; i < state.year_graph.length; i++) {
        sum += state.year_graph[i][1]
      }
      return sum
    },
    cat_2010(state){
      var data = state.cat_graph[0]
      return accessYearDatas(data)
    },
    cat_2010_init(state){
      var data = state.cat_graph[0]
      return accessYearDatas(data)
    },
    cat_2011(state){
      var data = state.cat_graph[1]
      return accessYearDatas(data)
    },
    cat_2012(state){
      var data = state.cat_graph[2]
      return accessYearDatas(data)
    },
    cat_2013(state){
      var data = state.cat_graph[3]
      return accessYearDatas(data)
    },
    cat_2014(state){
      var data = state.cat_graph[4]
      return accessYearDatas(data)
    },
    cat_2015(state){
      var data = state.cat_graph[5]
      return accessYearDatas(data)
    },
    cat_2016(state){
      var data = state.cat_graph[6]
      return accessYearDatas(data)
    },
    cat_2017(state){
      var data = state.cat_graph[7]
      return accessYearDatas(data)
    },
    cat_2018(state){
      var data = state.cat_graph[8]
      return accessYearDatas(data)
    },
    cat_2019(state){
      var data = state.cat_graph[9]
      return accessYearDatas(data)
    },
    cat_2020(state){
      var data = state.cat_graph[10]
      return accessYearDatas(data)
    },
    cat_2021 (state){
      var data = state.cat_graph[11]
      return accessYearDatas(data)
    },
    cat_2022 (state){
      var data = state.cat_graph[12]
      return accessYearDatas(data)
    }
  },
  modules: {

  }
})
